import { JSX } from 'react';
import './iconText.scss';

interface IconTextProps {
  icon: JSX.Element;
  text: string;
  wordBreak?: 'break-all' | 'break-word';
}

const IconText = ({ icon, text, wordBreak = 'break-word' }: IconTextProps) => (
  <div className="agx-icon-text" style={{wordBreak: wordBreak}}>
    {icon}
    {text}
  </div>
)

export default IconText;